<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-table :task="getList" :entity="entity" :actions="actions" :filter-entity="filterEntity" />
</template>
<script>
	import { PersonMilitary, PersonMilitaryFilter } from '@/modules/hub/data/person-military/list'
	import { PersonMilitaryService } from '@/modules/hub/services'
	export default {
		computed:
		{
			entity()
			{
				return PersonMilitary;
			},
			
			filterEntity()
			{
				return PersonMilitaryFilter;
			},

			service()
			{
				return new PersonMilitaryService();
			},

			actions()
			{
				return [
					{
						routeName: 'hub.personMilitary.create',
						resourceKey: 'action.create',
						iconName: 'bi-plus-circle',
						activeMode: 'always',
					},
					{
						routeName: 'hub.personMilitary.createImport',
						resourceKey: 'action.import',
						iconName: 'bi-upload',
						activeMode: 'always',
					},
					{
						routeName: 'hub.personMilitary.attachment',
						resourceKey: 'action.fileAttachment',
						iconName: 'bi-cloud-arrow-up',
						activeMode: 'single',
						dataTransferMode: 'store',
					},

					{
						resourceKey: 'action.update',
						iconName: 'bi-arrow-down-short',
						activeMode: 'single',
						children: [
							{
								routeName: 'hub.personMilitary.personRealsUpdate',
								resourceKey: 'hub.personRealsUpdate',
								iconName: 'bi-pen',
								activeMode: 'single',
								dataTransferMode: 'store',
							},
							{
								routeName: 'hub.personMilitary.update',
								resourceKey: 'hub.personMilitaryUpdate',
								iconName: 'bi-pen',
								activeMode: 'single',
								dataTransferMode: 'store',
							}
						],
					},

					{
						routeName: 'hub.personMilitary.delete',
						resourceKey: 'action.delete',
						iconName: 'bi-trash',
						activeMode: 'multiple',
						dataTransferMode: 'store',
					},
					{
						resourceKey: 'action.more',
						iconName: 'bi-arrow-down-short',
						activeMode: 'single',
						children: [{
							routeName: 'hub.personMilitary.detail',
							resourceKey: 'hub.personMilitaryDetail',
							iconName: 'bi-list-columns',
							activeMode: 'single',
							dataTransferMode: 'store',
						}]
					},

				]
			}
		},
		methods:
		{
			async getList(payload)
			{
				return await this.service.list(payload);
			}
		}
	}
</script>